const INDEX_ITEMS = [
  { icon: 'ri-heart-fill', label: '甜宠恋爱', count: '586部', desc: '霸道总裁、甜蜜契约、先婚后爱', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-booklet-line', label: '校园纯爱', count: '423部', desc: '同桌的你、青梅竹马、青春告白', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-sun-line', label: '治愈漫画', count: '312部', desc: '温暖日常、心灵抚慰、甜蜜治愈', color: 'bg-secondary-100 text-secondary-600' },
  { icon: 'ri-magic-line', label: '奇幻恋爱', count: '257部', desc: '穿越时空、异世界、超能力恋爱', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-building-line', label: '都市言情', count: '341部', desc: '职场恋爱、都市生活、成熟浪漫', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-global-line', label: '日漫精选', count: '468部', desc: '原版日系少女漫画汉化全集', color: 'bg-secondary-100 text-secondary-600' },
  { icon: 'ri-palette-line', label: '韩漫推荐', count: '289部', desc: '唯美韩系纯爱漫画精选', color: 'bg-primary-100 text-primary-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            分类导航
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">按类型快速找到喜欢的漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {INDEX_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#index"
              className={`flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group ${idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''}`}
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${item.color} group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.label}
                  </h3>
                  <span className="text-xs text-foreground-500">({item.count})</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}